module.exports = __webpack_public_path__ + "static/media/pt7.2367bda9.jpg";